










import {tagRecognitionRegex, tagSpliterRegex} from '@/store/constants';
import Vue, {PropType} from 'vue';

export default Vue.extend({
  name: 'TagContent',

  props: {
    text: {
      type: String as PropType<string>,
    },
  },

  computed: {
    /**
     * Transforme le contenu de l'annonce en un tableau de chaîne de caractères
     * ou alterne les contenus sans hashtag et les hashtag seul
     *
     * ex: "manger des #pommes, mûres de préférence"
     * revoit ["manger des ", "#pommes", ", mûres de préférence"]
     */
    contentArray(): { text: string, isLink: boolean }[] {
      return this.text
                 .split(tagSpliterRegex)
                 .reduce<{ strings: { text: string, isLink: boolean }[], previousChar: string }>((acc, str) => {
                   const isLink = tagRecognitionRegex.test(`${acc.previousChar}${str}`);
                   acc.previousChar = str.length ? str[str.length - 1] : str;
                   const text = str.replace(/\n/g, '<br/>');
                   if (text.length) {
                     acc.strings.push({
                       text,
                       isLink,
                     });
                   }
                   return acc;
                 }, {strings: [], previousChar: ''}).strings;
    },
  },

  methods: {
    /**
     * Charge la liste d'annonce filtrée sur le nom du hashtag
     */
    onTagFilter(tagName: string): Promise<void> {
      return new Promise((resolve, reject) => {
        this.$router.push({
          name: 'AdvertList',
          query: {tag: tagName.slice(1)},
        })
            .then(() => {
              resolve();
            })
            .catch(() => {
              reject();
            });
      });
    },
  },
});
